import { atom } from 'recoil';
import { ApiProps } from 'store/type';
import { BigNumber } from 'bignumber.js';

export const redirectState = atom<any>({
  key: 'redirectState',
  default: undefined,
});

export const pageLoading = atom<boolean>({
  key: 'pageLoading',
  default: false,
});

export const polkaService = atom<ApiProps | undefined>({
  key: 'polkaService',
  default: undefined,
});

export const allAccounts = atom({
  key: 'allAccounts',
  default: [],
});

type allTokensType = {
  tokenId: string;
  name: string;
  assetType: string;
  existentialDeposit: string;
  locked: boolean;
};

type assetArrayType = {
  tokenId: string;
  interestRatePerSec?: string | null;
  liquidationPenalty: string;
  liquidationRatio: string;
  maximumTotalDebitValue: string;
  notifiedCollateralRatio: string;
  requiredCollateralRatio: string;
};

export interface PolkaServiceData {
  assetArray: assetArrayType[];
  assetsKeys: string[];
  allTokens: allTokensType[];
  allLoanIds: string[];
  globalInterest: BigNumber;
  defaultExchangeRate?: string;
}

export const serviceData = atom<PolkaServiceData | undefined>({
  key: 'serviceData',
  default: undefined,
});

export const transactionStatusLabel = atom<string>({
  key: 'transactionStatusLabel',
  default: 'Processing...',
});
